import { UserB } from "app/pages/ok-admin/user-b/user-b";
import { FileUpload } from "app/pages/ok-core/photo/file-upload";

export class DocumentFile {
    id: string;
    companyId: string;
    department: string;
    type: string;
    name: string;
    competence: string;
    isFileSent: boolean
    url: string;
    status: string;
    contentType: string;
    typeUser: string;
    date: Date;
    expireDate: Date;
    creationDate: Date;
    deadline: Date;
    file: FileUpload = null
    fileBase: FileUpload = null
    user: UserB = null
}
